import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartSimpleItemByTempId = (id: number) => createSelector(cartState, (cart) => cart.itemsSimple.find((item) => item._Id === id) || null);
